import { ArrowRight, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919972579453";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Markite! I'd like to know more about your marketing services."
)}`;

export default function FinalCTA({ onBook }) {
  return (
    <section className="relative py-14 md:py-20" data-testid="final-cta-section">
      <div className="mx-auto max-w-5xl px-5 md:px-6">
        <div className="relative overflow-hidden rounded-3xl border border-blue-500/25 bg-gradient-to-br from-blue-950/70 via-slate-950/80 to-indigo-950/70 p-8 md:p-14">
          <div
            className="pointer-events-none absolute -top-20 left-1/2 h-48 w-[80%] -translate-x-1/2 rounded-full bg-blue-500/30 blur-3xl"
            aria-hidden
          />
          <div
            className="pointer-events-none absolute inset-0 opacity-40 grid-pattern"
            aria-hidden
          />
          <div className="relative text-center">
            <h2
              className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl"
              data-testid="final-cta-title"
            >
              Ready to <span className="gradient-text">Grow Faster?</span>
            </h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-slate-300 sm:text-base">
              Book a free 30-minute consultation. We'll map out a growth plan tailored to your business — no strings attached.
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
              <button
                type="button"
                onClick={onBook}
                className="btn-primary inline-flex h-12 items-center gap-2 rounded-full px-6 text-sm font-semibold text-white"
                data-testid="final-cta-book-btn"
              >
                Book Free Consultation <ArrowRight className="h-4 w-4" />
              </button>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-12 items-center gap-2 rounded-full bg-emerald-500 px-6 text-sm font-semibold text-white shadow-[0_10px_30px_-10px_rgba(16,185,129,0.7)] transition-all hover:-translate-y-0.5 hover:bg-emerald-400"
                data-testid="final-cta-whatsapp-btn"
              >
                <MessageCircle className="h-4 w-4" /> WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
